import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RecommendationsResponse, RecommendationQuery } from '../../../schemas/recommendation.schema';

export const recommendationApi = createApi({
  reducerPath: 'recommendationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_URL || '/api/v1',
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    getRecommendations: builder.query<RecommendationsResponse, RecommendationQuery>({
      query: (params) => ({
        url: '/recommendations',
        method: 'GET',
        params,
      }),
      keepUnusedDataFor: 5 * 60,
    }),
  }),
});

export const { useGetRecommendationsQuery } = recommendationApi;
